import { create } from 'zustand';

type CommentsStoreData = {
  isReady: boolean;
};
type CommentsStoreActions = {
  onReady: () => void;
};

export const useCommentsStore = create<
  CommentsStoreData & CommentsStoreActions
>((set) => ({
  isReady: false,
  onReady: () => {
    set({ isReady: true });
  },
}));
